import {
  getPorts,
} from '@/api';

const localState = {
  ports: [],
};

const actions = {
  async fetchPorts({ commit }) {
    const res = await getPorts();
    if (res.data.code === 0) {
      const { ports } = res.data;
      commit('setPorts', { ports });
    }
  },
};

const mutations = {
  setPorts(state, { ports }) {
    state.ports = ports;
  },
};

export default {
  actions,
  mutations,
  state: localState,
  namespaced: true,
};

